//client-entry.js
import { createApp } from './main.js';

const { app, router } = createApp()

// this assumes App.vue template root element has `id="app"`
router.onReady(() => {
  app.$mount('#app')
})


// WEBPACK FOOTER //
// ./src/entry-client.js